import { makeAutoObservable, runInAction } from 'mobx'
import { http } from '@/utils'

class DataStore {

    //数据列表初始化
    dataList = [];

    selectList = [];
    selectList2 = [];
    selectList3 = [];

    //总条数
    total = '';

    isActive = false

    //条数
    pagesize = 10;

    //当前页
    page = 1;

    //查询字段
    qyxxid = ''
    dyglid = ''
    sbxxid = ''
    createtime = ''

    constructor() {
        makeAutoObservable(this)
    }

    //下拉
    getSelectList = async () => {
        const res = await http.get(`/adminapi/equipmentmanagement?page=${1}&pagesize=${5000}`)
        if (res.data.code === 200) {
            runInAction(() => {
                let newdata = []
                JSON.parse(JSON.stringify(res.data.data.data.data)).forEach((item) => {
                    let newObj = {}
                    newObj.value = item.id
                    newObj.label = item.sbmc
                    newdata.push(newObj)
                    return newdata
                })
                this.selectList = newdata
            })
        }
    }

    getSelectList2 = async () => {
        const res = await http.get(`/adminapi/enterprisemanagement?page=${1}&pagesize=${5000}`)
        if (res.data.code === 200) {
            runInAction(() => {
                let newdata = []
                JSON.parse(JSON.stringify(res.data.data.data.data)).forEach((item) => {
                    let newObj = {}
                    newObj.value = item.id
                    newObj.label = item.qymc
                    newdata.push(newObj)
                    return newdata
                })
                this.selectList2 = newdata
            })
        }
    }

    getSelectList3 = async () => {
        const res = await http.get(`/adminapi/unitmanagement?page=${1}&pagesize=${5000}`)
        if (res.data.code === 200) {
            runInAction(() => {
                let newdata = []
                JSON.parse(JSON.stringify(res.data.data.data.data)).forEach((item) => {
                    let newObj = {}
                    newObj.value = item.id
                    newObj.label = item.dymc
                    newdata.push(newObj)
                    return newdata
                })
                this.selectList3 = newdata
            })
        }
    }

    //数据获取
    getDataList = async () => {
        const res = await http.get(`/adminapi/dataquery?page=${this.page}&pagesize=${this.pagesize}&qyxxid=${this.qyxxid}&dyglid=${this.dyglid}&sbxxid=${this.sbxxid}&createtime=${this.createtime}`)
        if (res.data.code === 200) {
            runInAction(() => {
                this.dataList = JSON.parse(JSON.stringify(res.data.data.data.data))
                this.total = res.data.data.data.total
            })
        }
    }
}

export { DataStore }
